import { ReactElement } from 'react';
import { LiteracyScreeningGradesModel } from '../../../types/LiteracyScreeningGradesModel';
import { LITERACY_SCREENING_MIDDLE_OF_YEAR_SESSION } from '../../../types/LiteracyScreeningModel';
import LiteracyScreeningSessionPanel, {
  LiteracyScreeningSessionEditState,
} from './LiteracyScreeningSessionPanel';

interface LiteracyScreeningMiddleOfYearPanelProps {
  grades: LiteracyScreeningGradesModel[];
  schoolYear: string;
  disabled?: boolean;
  resetKey?: number;
  onEditStateChange?: (state: LiteracyScreeningSessionEditState) => void;
}

const LiteracyScreeningMiddleOfYearPanel = ({
  grades,
  schoolYear,
  disabled = false,
  resetKey,
  onEditStateChange,
}: LiteracyScreeningMiddleOfYearPanelProps): ReactElement => (
  <LiteracyScreeningSessionPanel
    heading="Middle of Year Screening"
    session={LITERACY_SCREENING_MIDDLE_OF_YEAR_SESSION}
    grades={grades}
    schoolYear={schoolYear}
    disabled={disabled}
    resetKey={resetKey}
    onEditStateChange={onEditStateChange}
  />
);

export default LiteracyScreeningMiddleOfYearPanel;
